import sortBy from 'lodash-es/sortBy'
import sum from 'lodash-es/sum'
import { Sector } from 'recharts'

import {
  CHART_PERCENT_MAX,
  CHART_VALUE_SEPARATOR,
  CHART_VALUE_SHARE_EMPTY,
  PIE_ACTIVE_SECTOR_GROWTH,
} from './Chart.constants'
import { ChartLegendText } from './ChartLegendText'

export function getChartValueShare(value, total) {
  return total
    ? Math.round((value / total) * CHART_PERCENT_MAX)
    : CHART_VALUE_SHARE_EMPTY
}

// Largest remainder, so the rounded shares always add up to 100%.
export function getChartValuesShares(values, total) {
  const exactShares = values.map(value =>
    total ? (value / total) * CHART_PERCENT_MAX : CHART_VALUE_SHARE_EMPTY
  )
  const shares = exactShares.map(share => Math.floor(share))
  const roundedUpIndexes = sortBy(
    exactShares.map((_, index) => index),
    index => shares[index] - exactShares[index]
  ).slice(0, Math.round(sum(exactShares)) - sum(shares))

  return shares.map((share, index) =>
    roundedUpIndexes.includes(index) ? share + 1 : share
  )
}

export function formatChartValueWithShare({ share, value }) {
  return `${value}${CHART_VALUE_SEPARATOR}${share}%`
}

export function getChartItemColor({ colors, index, item }) {
  return item.color ?? colors[index % colors.length]
}

export function renderChartLegendText(value) {
  return <ChartLegendText>{value}</ChartLegendText>
}

export function renderChartPieActiveSector({
  innerRadius,
  outerRadius,
  ...restProps
}) {
  return (
    <Sector
      {...restProps}
      innerRadius={innerRadius - PIE_ACTIVE_SECTOR_GROWTH}
      outerRadius={outerRadius + PIE_ACTIVE_SECTOR_GROWTH}
    />
  )
}
